<template>
<v-container fluid px-0 py-0 secondary fill-height>


<v-layout row wrap align-top>

  <v-img
    align-top
    width="100%"
    src="img/hero/DSC03113.jpg"
    position="top right"
    gradient="to top right, rgba(100,115,201,.43), rgba(25,32,72,.7)">
    <v-container fill-height>
      <v-layout align-top>
        <v-flex text-xs-center pt-5 white--text>
          <h2 class="display-2 mb-4">Warner Connects Audit Tool</h2>
          <p class="title mb-4">Help make Warner Center more walkable!</p>
          <v-btn large color="secondary" class="mb-4" @click="startHandler">Get Started</v-btn>

       <v-container
          fluid
          grid-list-md>
          <v-layout row wrap>
            <v-flex xs12 sm6 md4 lg4 px-2 py-3
              v-for="(card, index) in cards"
              :key="'card-' + index">
              <v-card height="100%" class="elevation-12">
                <!-- <div style="height: 10px" :style="{ 'background-color': $vuetify.theme.primary }"></div> -->
                <v-img
                  :src="card.img"
                  height="150px">
                </v-img>
                <v-card-title primary-title>
                  <div class="headline">{{ index+1 }}) {{ card.title }}</div>
                </v-card-title>
                <v-card-text class="text-sm-left pt-0">
                  <span class="grey--text">{{ card.content }}</span>
                </v-card-text>
              </v-card>
            </v-flex>

          </v-layout>
        </v-container>



        </v-flex>
      </v-layout>
    </v-container>
  </v-img>
</v-layout>

<!-- <img v-for="n in 150"
  :src="`https://mdbootstrap.com/img/Photos/Slides/img%20(${n}).jpg`" style="width: 200px;"> -->
</v-container>
</template>

<script>

  export default {
    components: {
    },
    data() {
      return {
        cards: [
          { img: 'img/hero/DSC03379.jpg', title: 'Sign into App', content: 'Register first and then sign into the app.' },
          { img: 'img/hero/DSC03032.jpg', title: 'Record what you see', content: 'Start your audit and wander around, recording any conditions you find.' },
          { img: 'img/hero/DSC03232.jpg', title: 'Complete Audit', content: 'Finally, after recording several observations, publish the audit.' }
        ]
      }
    },
    methods: {
      startHandler () {
        this.$router.push({ name: 'user-dashboard' })
      }
    },
    mounted () {
      console.log(this.$vuetify.theme.secondary)
    },
  }
</script>
